/**
 * @generated SignedSource<<7146d8404acbae2106b002418fca665f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedSocialShareFacebook_item$data = {
  readonly title: string | null;
  readonly " $fragmentType": "PdpSharedSocialShareFacebook_item";
};
export type PdpSharedSocialShareFacebook_item$key = {
  readonly " $data"?: PdpSharedSocialShareFacebook_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSocialShareFacebook_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedSocialShareFacebook_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "1c3ecff5c251329613785aeae003faeb";

export default node;
